import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";


import { importProvidersFrom } from "@angular/core";
import { AppComponent } from "./app/app.component";
import { CdkTableModule } from "@angular/cdk/table";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatSliderModule } from "@angular/material/slider";
import { BrowserAnimationsModule, NoopAnimationsModule, provideAnimations } from "@angular/platform-browser/animations";
import { ReactiveFormsModule } from "@angular/forms";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { BrowserModule, bootstrapApplication } from "@angular/platform-browser";
import { AppRoutingModule } from "./app/app-routing.module";
import { ApiModule as ApiModuleNjdb } from "./app/_api/njdbpawebb/api.module";
import { ApiModule as ApiModuleJnb } from "./app/_api/jnbkarta/api.module";
import { authConfig } from "./app/auth.config";

import { environment } from "src/environments/environment";
import { NetDbService, EmptyNetDbService } from "./app/service/net-db.service";
import { AuthInterceptor, AuthModule } from "angular-auth-oidc-client";
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from "@angular/common/http";
import { AutofocusDirective } from '@app/directives/autofocus.directive'
import { NetDbNjdbpawebbService } from "@app/service/njdbpawebb/net-db-njdbpawebb.service";
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { ApmService } from "@app/service/apm.service";
import { NetDbJnbKartaService } from "@app/service/jnbkarta/net-db-jnbkarta.service";

//const apm: ApmService =  new ApmService();
//apm.initApm();


bootstrapApplication(AppComponent, {
    providers: [
        provideCharts(withDefaultRegisterables()),
        importProvidersFrom(AuthModule.forRoot({ config: authConfig }),
        ApiModuleNjdb.forRoot({ rootUrl: environment.baseApiUrl }),
        ApiModuleJnb.forRoot({ rootUrl: environment.baseApiUrl }), 
        AppRoutingModule, BrowserModule, FontAwesomeModule, ReactiveFormsModule, MatSliderModule, BrowserAnimationsModule, NoopAnimationsModule),
        AutofocusDirective,
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        {
            provide: NetDbService,
            useClass: environment.application === "NjdbPåWebb"
            ? NetDbNjdbpawebbService
            : environment.application === "JNBKarta"
            ? NetDbJnbKartaService
            : EmptyNetDbService,
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        ApmService
    ],
})
    .catch(err => console.error(err));
